import { KikGenericResponse, KikRestVerbs } from "@kikocosmeticsorg/uc-api-nest-common-fe";
import { OrdersAdditionalOrderDataOptions } from "@springtree/eva-services-core";
import { useQuery } from "@tanstack/react-query";

import { useAuthContext } from "~/contexts/auth";
import { HttpService } from "~/services/http";
import { ApiConstants } from "~/shared/api/api-constants.class";
import { GuestTrackOrderSummary } from "~/shared/guest-track-order/guest-track-order-summary";
import { normaliseGuestTrackOrderSummary } from "~/shared/guest-track-order/normalise-guest-track-order-summary.function";
import Constants from "~/utils/constants";

export function useGuestTrackYourOrder() {
  const { guestTrackingToken } = useAuthContext();

  return useQuery({
    queryKey: ["guestTrackOrderSummary", guestTrackingToken],
    staleTime: Constants.DEFAULT_STALE_TIME,
    queryFn: async () => {
      const response = await HttpService.$http<KikGenericResponse<GuestTrackOrderSummary>>({
        url: ApiConstants.endpointsMapiV1.ecoGuestTrackOrderSummary,
        method: KikRestVerbs.POST,
        headers: {
          Authorization: `Bearer ${guestTrackingToken}`,
        },
        body: {
          ProductProperties: Constants.ORDER_DETAIL_INCLUDED_FIELDS,
          IncludeProductRequirements: true,
          IncludeGiftWrapping: true,
        } as OrdersAdditionalOrderDataOptions,
      });

      if (!response?.data?.orderDetail?.Result) {
        return null;
      }

      return normaliseGuestTrackOrderSummary(response.data);
    },
    enabled: !!guestTrackingToken,
  });
}
